import { useClientOnly } from "library/ClientOnly";
import { browserData } from ".";
export const useBrowserData = () => {
  return useClientOnly(browserData) ?? {};
};